import { render, staticRenderFns } from "./BrowseLibraryDrawer.vue?vue&type=template&id=4ef25b33"
import script from "./BrowseLibraryDrawer.vue?vue&type=script&lang=js"
export * from "./BrowseLibraryDrawer.vue?vue&type=script&lang=js"
import style0 from "./BrowseLibraryDrawer.vue?vue&type=style&index=0&id=4ef25b33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports